export const LOGINMODUL_LOGIN_REQUEST = "LOGINMODUL_LOGIN_REQUEST";
export const LOGINMODUL_LOGIN_SUCCESS = "LOGINMODUL_LOGIN_SUCCESS";
export const LOGINMODUL_LOGIN_FAIL = "LOGINMODUL_LOGIN_FAIL";
export const LOGINMODUL_LOGIN_RESET = "LOGINMODUL_LOGIN_SUCCESS";
